import { useEffect, useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBoxProps {
  initialValue?: string;
  size?: "sm" | "md" | "lg";
  placeholder?: string;
  autoFocus?: boolean;
}

const sizeMap = {
  sm: "h-9 text-sm pl-9 pr-2",
  md: "h-10 text-sm pl-10 pr-3",
  lg: "h-12 text-base pl-12 pr-4",
};

export default function SearchBox({
  initialValue = "",
  size = "md",
  placeholder = "搜索电影、电视剧或影视资讯",
  autoFocus = false,
}: SearchBoxProps) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleSubmit = (event?: FormEvent) => {
    event?.preventDefault();
    const keyword = value.trim();
    if (!keyword) return;
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
  };

  const iconSize = size === "lg" ? "text-xl" : "text-base";

  return (
    <form
      onSubmit={handleSubmit}
      className="relative w-full"
      role="search"
      aria-label="影视搜索"
    >
      <span
        className={`pointer-events-none absolute left-3 top-1/2 flex -translate-y-1/2 items-center justify-center text-foreground-400 ${iconSize}`}
      >
        <i className="ri-search-line"></i>
      </span>
      <input
        type="search"
        name="q"
        value={value}
        autoFocus={autoFocus}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        className={`w-full rounded-full border border-background-300 bg-background-100 text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-accent-400 focus:bg-background-50 focus:ring-2 focus:ring-accent-100 ${sizeMap[size]}`}
      />
      <button
        type="submit"
        aria-label="搜索"
        className="absolute right-1.5 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full bg-accent-500 text-sm text-background-50 transition-colors hover:bg-accent-600"
      >
        <i className="ri-arrow-right-line"></i>
      </button>
    </form>
  );
}